var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"master"},[_c('About',{attrs:{"show-top-bar":false}}),_c('div',{staticClass:"wrapper fixed-to-bottom"},[_c('router-link',{staticClass:"btn btn-l",attrs:{"to":"palette"}},[_vm._v("C'est parti !")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }